import * as z from "zod";

export const WarrantyRegistrationRewardsFlatTeamSettingsSchema = z.object({
  "warranties/registrationRewardDiscountId": z.string().nullish(),
});
